// LeaderboardCategoryUser.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import UserItem from '../container/UserItem.js';

export const LeaderboardCategoryUser = ({
  userId = '',
  username = '',
  place = 4,
  fetchUser = () => null,
  region = null,
  category = null,
  range = null,
}) => {
  useEffect(() => {
    const nextTick = setTimeout(() => {
      const needFetchUser = !username && userId;
      if (needFetchUser) {
        fetchUser();
      }
    });

    return () => {
      clearTimeout(nextTick);
    };
  }, [userId, username, fetchUser]);

  return (
    <StyledLeaderboardCategoryUser>
      <UserItem
        userId={userId}
        place={place}
        region={region}
        category={category}
        range={range}
      />
    </StyledLeaderboardCategoryUser>
  );
};

LeaderboardCategoryUser.propTypes = {
  userId: PropTypes.string,
  username: PropTypes.string,
  place: PropTypes.number,
  fetchUser: PropTypes.func,
  region: PropTypes.string,
  category: PropTypes.string,
  range: PropTypes.string,
};

const StyledLeaderboardCategoryUser = styled.div``;

export default LeaderboardCategoryUser;
